import { render, staticRenderFns } from "./myAttentions.vue?vue&type=template&id=d64a4cea&scoped=true"
import script from "./myAttentions.vue?vue&type=script&lang=js"
export * from "./myAttentions.vue?vue&type=script&lang=js"
import style0 from "./myAttentions.vue?vue&type=style&index=0&id=d64a4cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a4cea",
  null
  
)

export default component.exports